// extracted by mini-css-extract-plugin
export default {"content":"GetInTouch_content__57eT1","texts":"GetInTouch_texts__3CEdp"};